"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const NAMES = {
  ajaxModuleUpdate: 'ajax-module-update-event',
  allCatsLinkClicked: 'all-cats-link-clicked-event',
  changeToTab: 'change-to-tab-event',
  closeProfileEditDrawer: 'close-profile-edit-drawer-event',
  openOverflowDrawer: 'open-overflow-drawer-event',
  openMobileCatLayer: 'open-mobile-cat-layer-event',
  openShareDrawer: 'open-share-drawer-event',
  presenceEdit: 'presenceEdit',
  stickyHeaders: 'sticky-headers-event',
  stickyLeftNav: 'sticky-left-nav-event',
  tabHasChanged: 'str-tab-change-event',
  toggleLeftNav: 'toggle-left-nav-event',
  toggleLeftNavDone: 'toggle-left-nav-done-event'
};
var _default = {
  ajaxModuleUpdate: newEvent(NAMES.ajaxModuleUpdate),
  allCatsLinkClicked: newEvent(NAMES.allCatsLinkClicked),
  changeToTab: newEvent(NAMES.changeToTab),
  openOverflowDrawer: newEvent(NAMES.openOverflowDrawer),
  openMobileCatLayer: newEvent(NAMES.openMobileCatLayer),
  openShareDrawer: newEvent(NAMES.openShareDrawer),
  presenceEdit: newEvent(NAMES.presenceEdit),
  stickyHeaders: newEvent(NAMES.stickyHeaders),
  stickyLeftNav: newEvent(NAMES.stickyLeftNav),
  tabHasChanged: newEvent(NAMES.tabHasChanged),
  toggleLeftNav: newEvent(NAMES.toggleLeftNav),
  toggleLeftNavDone: newEvent(NAMES.toggleLeftNavDone)
};
exports.default = _default;

function newEvent(eventName) {
  return {
    listen: callback => {
      document.addEventListener(eventName, evt => {
        callback(evt.detail);
      });
    },
    dispatch: data => {
      const tabEvt = new CustomEvent(eventName, {
        detail: data
      });
      document.dispatchEvent(tabEvt);
    }
  };
}